var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8141 20.8494L15.7207 14.704C17.185 12.9312 17.9151 10.6572 17.7593 8.35518C17.6035 6.05317 16.5737 3.90036 14.8842 2.3446C13.1946 0.788838 10.9753 -0.0500981 8.68804 0.00231604C6.40077 0.0547302 4.22158 0.994459 2.60382 2.62601C0.986055 4.25756 0.0542676 6.45532 0.00229647 8.76209C-0.0496747 11.0689 0.782171 13.307 2.32479 15.011C3.8674 16.715 6.00202 17.7536 8.28457 17.9107C10.5671 18.0678 12.8219 17.3314 14.5798 15.8547L20.6732 22L21.8141 20.8494ZM1.64257 8.98021C1.64257 7.53173 2.06847 6.11578 2.8664 4.91141C3.66433 3.70705 4.79846 2.76836 6.12537 2.21405C7.45228 1.65974 8.91237 1.51471 10.321 1.7973C11.7297 2.07988 13.0236 2.77739 14.0391 3.80162C15.0547 4.82584 15.7463 6.13079 16.0265 7.55144C16.3067 8.97208 16.1629 10.4446 15.6133 11.7828C15.0637 13.1211 14.1329 14.2649 12.9387 15.0696C11.7445 15.8743 10.3406 16.3038 8.90432 16.3038C6.97904 16.3017 5.13323 15.5294 3.77185 14.1564C2.41047 12.7834 1.64471 10.9219 1.64257 8.98021Z",
    fill: "black",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.e1ec12f308827f189ba70336fda5f4db.svg";
export { ForwardRef as ReactComponent };